import React from "react";
import ToClientRelation from "./ToClientRelation";
import { routes } from "utilities/routing/generatedRoutes";
import CultureFlag from "components/Culture/CultureFlag";
import UserWithAvatar from "components/Atoms/UserWithAvatar";
import SubLabel from "components/Atoms/Sublabel";

interface Props {
  user: server.dto.UserForAdminOne
}

const UserAdminOneRowCard = ({ user }: Props) => {
  const lastActivityText = user.lastActivityUtc
    ? `${RESX.SoUser.LastActivity} ${user.lastActivityText}`
    : user.lastActivityText;

  return <>
    <UserWithAvatar nameHref={routes.user_DetailAdminOne(user.userId).absolute} user={user} style={{ flex: "1 1 150px" }}>
      <SubLabel small>{lastActivityText}</SubLabel>

      {user.hubSpotContactId && <div>
        <a href={`https://app.hubspot.com/contacts/5257648/record/0-1/${user.hubSpotContactId}/`} target="_blank" rel="noreferrer">
          HubSpot
        </a>
      </div>}
    </UserWithAvatar>

    <div className="flex gap" style={{ flex: "1 1 150px" }}>
      <div>
        <CultureFlag lcid={user.culture} size="large" />
      </div>
      <div>
        <div>{user.username}</div>
        <div>{user.email}</div>
        <SubLabel small>user: {user.userId}</SubLabel>
      </div>
    </div>
    <div style={{ flex: "2 1 200px" }}>
      <ToClientRelation user={user} />
    </div>
  </>;
};

export default UserAdminOneRowCard;